export var CRUD_CHANGE_LIST_PARAMS = 'AOR/CRUD_CHANGE_LIST_PARAMS';
export var changeListParams = function changeListParams(resource, params) {
  return {
    type: CRUD_CHANGE_LIST_PARAMS,
    payload: params,
    meta: {
      resource: resource
    }
  };
};